import React from 'react'
// import { LangContext } from '../../context/lang-context'

import FormSkel from './FormSkel'
import { useState } from 'react'

export default ({ clientData, handleSubmit, handleClose }) => {
  return (
    <FormSkel
      headerText={clientData ? 'Edycja klienta' : 'Dodaj klienta'}
      handleClose={handleClose}
    >
      <form onSubmit={handleSubmit} id="modal-form" autoComplete="off">
        <div className="form-group">
          <input style={{display: "none"}} onChange={()=>{}} name="oldName" value={clientData && clientData.Abbreviation} form='modal-form'/>
          <label className="h6">Nazwa klienta</label>
          <input
            name="name"
            className="form-control"
            defaultValue={clientData && clientData.Name || ""}
            required
          />
        </div>
        <div style={clientData.CustomerId === '3' ? {display:'none'} : {display:'block'}}>
          <label className="h6">Trzyliterowa nazwa bazy danych</label>
          <input
            name="abbreviation"
            className="form-control"
            defaultValue={clientData && clientData.Abbreviation || ""}
          />
        </div>
        {!clientData && (
          <div>
            <label className="h6">Adres email właściciela</label>
            <input
              name="ownermail"
              className="form-control"
              defaultValue={""}
            />
          </div>
        )}
      </form>
    </FormSkel>
  )
}
